// Manual creators list - edit this file to add/remove creators
// Format: { username/email, password }
export const creators = [
  {
    email: 'BryanBeCookin@gmail.com',
    password: '1bHlBpW3NqD8Fvrq',
    CreatorId: "65"
  },
  {
    email: 'chef@savory.ink',
    password: 'savory2024',
    CreatorId: "999"
  }
];

export const validateCreator = (email, password) => {
  return creators.find(
    creator => creator.email.toLowerCase() === email.toLowerCase() && creator.password === password
  );
};
